import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CiCircleFilledSvg from "@ant-design/icons-svg/es/asn/CiCircleFilled";
import AntdIcon from "../components/AntdIcon";
var CiCircleFilled = function CiCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CiCircleFilled.displayName = 'CiCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(CiCircleFilled);